<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('aShopSms.queryCondition') }}</div>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input v-model="aShopSmsInfo.conditions.shopNameLike" :placeholder="$t('aShopSms.shopNamePlaceholder')"
              clearable></el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" size="small" @click="_queryAShopSmsMethod">
              {{ $t('aShopSms.query') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('aShopSms.shopSms') }}</div>
      </div>
      <div class="">
        <el-table :data="aShopSmsInfo.smses" border style="width: 100%">
          <el-table-column prop="shopName" :label="$t('aShopSms.shopName')" align="center"></el-table-column>
          <el-table-column prop="smsCount" :label="$t('aShopSms.smsCount')" align="center"></el-table-column>
          <el-table-column prop="smsSwitch" :label="$t('aShopSms.smsSwitch')" align="center">
            <template slot-scope="scope">
              {{ scope.row.smsSwitch === 'ON' ? $t('aShopSms.on') : $t('aShopSms.off') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('aShopSms.operation')" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_openEditAShopSmsModel(scope.row)">
                {{ $t('aShopSms.edit') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="aShopSmsInfo.conditions.page"
          :page-size="aShopSmsInfo.conditions.row" layout="total, prev, pager, next"
          :total="aShopSmsInfo.total"></el-pagination>
      </div>
    </el-card>

    <edit-a-shop-sms ref="editAShopSms" @refresh="queryAShopSms"></edit-a-shop-sms>
  </div>
</template>

<script>
import { listAShopSms } from '@/api/shop/shopSmsApi'
import EditAShopSms from '@/components/shop/editAShopSms.vue'

export default {
  name: 'AShopSms',
  components: {
    EditAShopSms
  },
  data() {
    return {
      aShopSmsInfo: {
        smses: [],
        total: 0,
        conditions: {
          shopNameLike: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAShopSmss(this.aShopSmsInfo.conditions.page, this.aShopSmsInfo.conditions.row)
  },
  methods: {
    queryAShopSms() {
      this._listAShopSmss(1, 10)
    },
    async _listAShopSmss(page, rows) {
      this.aShopSmsInfo.conditions.page = page
      this.aShopSmsInfo.conditions.row = rows

      try {
        const res = await listAShopSms(this.aShopSmsInfo.conditions)
        this.aShopSmsInfo.total = res.total
        this.aShopSmsInfo.smses = res.data
      } catch (error) {
        console.error('获取店铺短信列表失败:', error)
      }
    },
    _openEditAShopSmsModel(row) {
      this.$refs.editAShopSms.open(row)
    },
    _queryAShopSmsMethod() {
      this._listAShopSmss(1, this.aShopSmsInfo.conditions.row)
    },
    handleCurrentChange(val) {
      this._listAShopSmss(val, this.aShopSmsInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
}

.ibox-content {
  padding: 15px;
}
</style>